import { Injectable, inject } from '@angular/core';
import {Observable} from 'rxjs';
import {Branch} from '../master-data/master-data.model';
import { HttpClient, HttpResponse } from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {API_URL} from '../../environments/environment';
import {SNACKBAR_BRANCH_ADD_ERROR, SNACKBAR_BRANCH_ADD_SUCCESS} from '../../locale/consts.en';

@Injectable({
  providedIn: 'root'
})
export class BranchesService {
  private http = inject(HttpClient);
  private snackBar = inject(MatSnackBar);


  getAllBranches(): Observable<Branch[]> {
    return this.http.get<Branch[]>(API_URL + 'branch');
  }

  updateBranch(branch): Observable<HttpResponse<Branch>> {
    console.log('Update branch', branch);
    return this.http.post<Branch>(API_URL + 'branch', branch, {
      observe: 'response'
    });
  }

  handleResponse(response: HttpResponse<unknown>) {
    if (response.status === 200 || response.status === 201) {
      this.snackBar.open(SNACKBAR_BRANCH_ADD_SUCCESS, '', {duration: 2000, panelClass: 'app-snackbar-success'});
      console.log('Save OK!');

    } else {
      this.snackBar.open(SNACKBAR_BRANCH_ADD_ERROR, '', {duration: 2000, panelClass: 'app-snackbar-alert'});
    }

  }
}
